import DetailsModal from './DetailsModal';

export default DetailsModal;


// WEBPACK FOOTER //
// ./src/components/modals/details-modal/index.js